<template>
  <div class="footer-container">
    <ZjunFooter @clickLink="toHelpCenter" :list="quickLinkList" />
    <div class="footer-bottom-container">
      <p style="margin-bottom:8px">经营许可证编号：陕B2-20210113 | <a class="hover_02" target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002002175"
          >陕公网安备:61019002002175</a>
        </p>
      <ul class="footer-bottom-des">
        <li
          v-for="item in companyDesList"
          :key="item.path"
          class="cursor hover_02 footer-bottom-item"
          @click="toCompanyDes(item.path)"
        >
          {{ item.name }}
        </li>
      </ul>
      <p class="record-content">
        版权所有  &copy; 2020-2021
        <a class="hover_02" style="margin-right:4px" target="_blank" href="http://www.jingyingbang.com">经营帮科技有限公司</a>
        <a class="hover_02" target="_blank" href="https://beian.miit.gov.cn/">陕ICP备2022005064号</a>
      </p>
    </div>
  </div>
</template>

<script>
import { ZjunFooter } from "zjkjui";
import apiHelp from "@/api/apiHelp";
export default {
  name: "Bottom",
  components: {
    ZjunFooter,
  },
  data() {
    return {
      quickLinkList: [],
      companyDesList: [
        { name: "企业简介", path: "companyProfiles" },
        { name: "服务协议", path: "contact-us" },
        { name: "联系我们", path: "service-agreement" },
      ],
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      let res = await apiHelp.getQuickLink();
      this.quickLinkList = (res.data && res.data.data) || [];
    },
    toHelpCenter(id) {
      window.open(`${process.env.VUE_APP_HOME}/content?id=${id.contentId}`, "_blank");
    },
    toCompanyDes(path) {
      window.open(`${process.env.VUE_APP_HOME}/${path}`, "_blank");
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  a {
    color: #8d8d8d !important;
  }
  .hover_02:hover {
    color: #8d8d8d !important;
}
.footer-container {
  width: 100%;
  background-color: #fff;
  margin-top: 10px;
}
.footer-bottom-container {
  color: #8d8d8d;
  font-size: 12px;
  text-align: center;
  padding: 20px 0;
}
.record-content {
  a {
    color: #8d8d8d;
  }
}
.footer-bottom-des {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.footer-bottom-item {
  display: flex;
  align-items: center;
  &::after {
    content: "";
    display: inline-block;
    width: 1px;
    height: 13px;
    background-color: #8d8d8d;
    margin: 0 8px;
  }
}
.footer-bottom-item:nth-last-of-type(1)::after {
  display: none;
}
</style>
